import React from 'react';
import { useNavigate } from 'react-router-dom';
import promoImage from 'assets/img/promo_modal.png';
import Axios from 'utils/Axios';
import toast from 'react-hot-toast';

class PromotionModal extends React.Component {
  state = {
    email: '',
    loading: false,
    couponCode: null,
    error: null,
    emailSent: false,
  };

  handleEmailChange = e => {
    this.setState({ email: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();
    const { email } = this.state;
    const couponCode = 'NUVETA50'; // The Black Friday coupon code

    this.setState({ loading: true, error: null });

    try {
      // Make API call to backend to claim the coupon
      await Axios.post(`/coupons/claim/${couponCode}`, {
        email: email,
      });

      // Show coupon on success
      this.setState({
        loading: false,
        couponCode: couponCode,
        emailSent: true,
      });

      // Store claim timestamp in localStorage (hide for 5 minutes)
      const claimTime = new Date().getTime();
      localStorage.setItem('promotionClaimedAt', claimTime.toString());

      toast.success('Coupon claimed successfully!');
    } catch (error) {
      console.error('Error claiming coupon:', error);
      // Show coupon even if backend fails, but don't say email was sent
      this.setState({
        loading: false,
        couponCode: couponCode,
        emailSent: false,
      });

      // Store claim timestamp even on error
      const claimTime = new Date().getTime();
      localStorage.setItem('promotionClaimedAt', claimTime.toString());

      toast.success('Here is your coupon code!');
    }
  };

  handleContinueWithout = e => {
    e.preventDefault();
    const $ = window.$;
    $('#promotionModal').modal('hide');
    this.props.onHide();
  };

  handleClose = () => {
    const $ = window.$;
    $('#promotionModal').modal('hide');
    this.props.onHide();
  };

  handleStartShopping = () => {
    const $ = window.$;
    $('#promotionModal').modal('hide');
    this.props.onHide();

    // Wait for modal to close before navigating
    setTimeout(() => {
      this.props.navigate('/order-plan/zip-code');
    }, 300);
  };

  render() {
    const { email, loading, couponCode, emailSent } = this.state;

    return (
      <div
        className="modal fade"
        id="promotionModal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content promotion-modal-content">
            <div className="modal-body p-0">
              <div className="row g-0">
                <div className="col-md-6 promotion-image-container">
                  <img
                    src={promoImage}
                    alt="Delicious meals"
                    className="promotion-image"
                  />
                </div>
                <div className="col-md-6 promotion-content">
                  {!couponCode ? (
                    <>
                      <div className="promotion-header">
                        <div className="promotion-logo">NUVETA</div>
                        <h2 className="promotion-title">BLACK FRIDAY</h2>
                        <h2 className="promotion-title">SALE</h2>
                      </div>
                      <div className="promotion-body">
                        <p className="promotion-text">
                          Unlock your <strong>50% OFF</strong>
                        </p>
                        <p className="promotion-text">weekly menu meals</p>
                        <p className="promotion-text mb-4">from Nov 20-30</p>

                        <form onSubmit={this.handleSubmit}>
                          <input
                            type="email"
                            className="promotion-input"
                            placeholder="Your email address"
                            value={email}
                            onChange={this.handleEmailChange}
                            required
                            disabled={loading}
                          />
                          <button
                            type="submit"
                            className="promotion-button"
                            disabled={loading}
                          >
                            {loading ? 'CLAIMING...' : 'CLAIM 50% OFF'}
                          </button>
                        </form>

                        <button
                          className="promotion-continue"
                          onClick={this.handleContinueWithout}
                          disabled={loading}
                        >
                          CONTINUE WITHOUT OFFER
                        </button>

                        <p className="promotion-disclaimer">
                          By entering your email, you agree to receive updates
                          and promotional offers from Nuveta. You can
                          unsubscribe at any time.
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="promotion-header">
                        <div className="promotion-logo">NUVETA</div>
                        <h2 className="promotion-title">SUCCESS!</h2>
                      </div>
                      <div className="promotion-body">
                        <p className="promotion-text mb-3">
                          Your coupon code is:
                        </p>
                        <div className="promotion-coupon-code">
                          {couponCode}
                        </div>
                        <p className="promotion-text mt-3 mb-4">
                          Use this code at checkout to get{' '}
                          <strong>50% OFF</strong>
                        </p>

                        <button
                          className="promotion-button"
                          onClick={this.handleStartShopping}
                        >
                          START SHOPPING
                        </button>

                        {emailSent && (
                          <p className="promotion-disclaimer mt-3">
                            This code has been sent to your email: {email}
                          </p>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Wrapper component to provide navigate function
const PromotionModalWithNavigate = props => {
  const navigate = useNavigate();
  return <PromotionModal {...props} navigate={navigate} />;
};

export default PromotionModalWithNavigate;
